import * as React from 'react';
import { FormSections, FormSubSections, ProgramContainer } from '../entities/formTemplateDataType';
import { ElementComponent } from './ElementComponent';
import { User } from '../entities/User';


interface Props {
  isEng: boolean;
  activeSubSection: FormSubSections;
  user?: User;
  editable: boolean;
  roleBasedEditable?: boolean;
  topEntity?;
  roleBased?: boolean;
  ownerEditableOnly?: boolean;
  renderHeader?:boolean;
  returnIndex?: number;
  callback: (programContainer: ProgramContainer)=> void;
  callbackStepIndex?: (index: number, returnIndex?:number) => void;
  callbackValidate?: (errors:any)=>void
}

interface State {
  // activeSubSection: FormSubSections;
  // editable: boolean;
  // topEntity;
}

export class SubSectionComponent extends React.Component<Props, State> {
  UseAsterisks
  constructor(props: Props) {
    super(props);

    // this.state = {
    //   activeSubSection: this.props.activeSubSection,
    //   editable: this.props.editable,
    //   topEntity: this.props.topEntity
    // };

    this.UseAsterisks=this.props.activeSubSection.parent?.parent?.UseAsterisks;
   
  }

  //get subsection element with FilterField
  render() {
    var panelContents = [];

    panelContents.push(
      <div key={'subSec_' + this.props.activeSubSection.Id} style={{display: this.props.activeSubSection.Visible == false ? 'none': 'block'}}>
        {this.generatePanelContent(this.props.activeSubSection)}
      </div>
    );
    //panelContents.push(<br key={'br_' + this.props.activeSubSection.Id} />);

    return panelContents;
  }

  generatePanelContent = (subSection: FormSubSections) => {
    var controlArray = [];

    subSection.ListOfFormSectionElements
    .filter(item=>true!==item.FieldMustBeAtTop)
      .sort((a, b) => a.Sequence - b.Sequence)
      .forEach(element => {
        element.findFieldByName = (fieldName) => {
          const root = this.props.activeSubSection.parent.parent;

          const formList = root.ListOfFormSections;
          let eleReturned;
          try {
            formList.forEach(section => {
              if(section.Visible == false) return;
              section.ListOfFormSubSections.forEach(sub => {
                const elements = sub.ListOfFormSectionElements;
                elements.forEach(ele => {
                  if (ele.LoadBindName == fieldName) {
                    eleReturned = ele;
                    throw new Error('Exit all loops');
                  }
                })
              })
            });
          } catch {
            return eleReturned;
          }
          return null;
        }
        element.findSectionByTitle=(sectionTitle)=>{
          const root = this.props.activeSubSection.parent.parent;
          const formList = root.ListOfFormSections as FormSections[];
          for(let form of formList){
            if (form.ENUTitle==sectionTitle){
              return form;
            }
          }

          return null;
        }
          
        controlArray.push(
          <ElementComponent
            key={element.LoadBindName + "_" + subSection.Id + '_ElementComponent_field_' + element.Id}
            isEng={this.props.isEng}
            field={element}
            editable={this.props.editable}
            roleBasedEditable={this.props.roleBasedEditable}
            callbackElement={(container) => {
              this.props.callback(container);
            }}
            user={this.props.user}
            topEntity={this.props.topEntity}
            roleBased={this.props.roleBased}
            usedForFilter={false}
            ownerEditableOnly={this.props.ownerEditableOnly}
            UseAsterisks={this.UseAsterisks}
            returnIndex={this.props.returnIndex}
            callbackValidate={(errors)=>this.props.callbackValidate(errors)}
            callbackStepIndex={(index,returnIndex)=>this.props.callbackStepIndex(index, returnIndex)}
          />);
      }, this);
   
    return controlArray;
  }

}
